import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import React, { Component } from "react";
import Login from "../containers/Login/Login";
import Main from "../containers/Main/Main";
import { Route, Switch } from "react-router-dom";
import { ConnectedRouter } from "connected-react-router";
import PrivateRoute from "./PrivateRoute";
import { checkAuth, getConfig, getUsers, getJobPacks, getGroups } from "./actions";
import { connect } from "react-redux";
import { hot } from "react-hot-loader";

var RouterComponent = /*#__PURE__*/function (_Component) {
  _inherits(RouterComponent, _Component);

  var _super = _createSuper(RouterComponent);

  function RouterComponent(props) {
    var _this;

    _classCallCheck(this, RouterComponent);

    _this = _super.call(this, props);
    props.getConfig();
    props.checkAuth();
    props.getUsers();
    props.getJobPacks();
    props.getGroups();
    return _this;
  }

  _createClass(RouterComponent, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(ConnectedRouter, Object.assign({
        onUpdate: function onUpdate() {
          return window.scrollTo(0, 0);
        },
        history: this.props.history
      }, this.props), /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
        path: "/login",
        component: Login
      }), /*#__PURE__*/React.createElement(Route, {
        path: "/logout",
        component: Login
      }), /*#__PURE__*/React.createElement(PrivateRoute, Object.assign({}, this.props, {
        path: "/",
        component: Main
      })), /*#__PURE__*/React.createElement(PrivateRoute, Object.assign({}, this.props, {
        path: "",
        component: Main
      })), /*#__PURE__*/React.createElement(PrivateRoute, Object.assign({}, this.props, {
        path: "/dashboard",
        component: Main
      }))));
    }
  }]);

  return RouterComponent;
}(Component);

export default connect(null, {
  checkAuth: checkAuth,
  getConfig: getConfig,
  getUsers: getUsers,
  getJobPacks: getJobPacks,
  getGroups: getGroups
})(hot(module)(RouterComponent));